module.exports = __webpack_public_path__ + "static/media/smartRecruitersColorLogo.03bf61ae.svg";